__turbopack_context__.v({
  "arrowFill": "lXSWTq_arrowFill",
  "arrowInnerStroke": "lXSWTq_arrowInnerStroke",
  "arrowOuterStroke": "lXSWTq_arrowOuterStroke",
  "inlineActions": "lXSWTq_inlineActions",
  "inlineIconButton": "lXSWTq_inlineIconButton",
  "menuArrow": "lXSWTq_menuArrow",
  "menuItem": "lXSWTq_menuItem",
  "menuItemIcon": "lXSWTq_menuItemIcon",
  "menuPopup": "lXSWTq_menuPopup",
  "menuPositioner": "lXSWTq_menuPositioner",
  "menuSeparator": "lXSWTq_menuSeparator",
  "menuTrigger": "lXSWTq_menuTrigger",
  "menuTriggerInner": "lXSWTq_menuTriggerInner",
});
